import { useEffect, useRef, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FollowUs from "../Footer/FollowUs";
import LetsGet from "../Footer/LetsGet";
import { motion, AnimatePresence } from "framer-motion";
import { MdArrowBackIos } from "react-icons/md";
import { MdArrowForwardIos } from "react-icons/md";

const slides = [0, 1, 2];

const BrochureCreation = () => {
    //mobile card-4
    const [active, setActive] = useState(0);

  // Auto slide card-4
  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(intervalRef.current);
  }, []);

  const startAutoSlide = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 4000);
  };

  const handleDotClick = (index) => {
    setActive(index);
    startAutoSlide();
  };

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
    //mobile card-mobile
      const scrollRef = useRef(null);
      const intervalRef = useRef(null);

      const scroll = (direction) => {
    if (!scrollRef.current) return;

    const scrollAmount = 280;
    scrollRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });

    stopAutoScroll();
    startAutoScroll();
  };

  const startAutoScroll = () => {
  stopAutoScroll(); // force reset

  intervalRef.current = setInterval(() => {
    if (!scrollRef.current) return;

    const el = scrollRef.current;
    const maxScroll = el.scrollWidth - el.clientWidth;

    if (el.scrollLeft >= maxScroll - 5) {
      el.scrollTo({ left: 0, behavior: "smooth" });
    } else {
      el.scrollBy({ left: 280, behavior: "smooth" });
    }
  }, 3000);
};

const stopAutoScroll = () => {
  if (intervalRef.current) {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  }
};

// useEffect(() => {
//   startAutoScroll();
//   return () => stopAutoScroll();
// }, []);


  // card-mobile design
  const [activeBrochure, setActiveBrochure] = useState(null);
    const brochures = [
    {
      id: 1,
      title: "Magic Metals",
      year: "2025",
      img: "/assets/card1.png",
    },
    {
      id: 2,
      title: "RPJ Hotel",
      year: "2024",
      img: "/assets/card2.png", 
    },
    {
      id: 3,
      title: "Soham Villas",
      year: "2025",
      img: "/assets/card3.png",
    },
    {
      id: 4,
      title: "Magic Metals",
      year: "2025",
      img: "/assets/card1.png",
    },
    {
      id: 5,
      title: "RPJ Hotel",
      year: "2024",
      img: "/assets/card2.png",
    },
    {
      id: 6,
      title: "Soham Villas",
      year: "2025",
      img: "/assets/card3.png",
    },
    {
      id: 7,
      title: "Magic Metals",
      year: "2025",
      img: "/assets/card1.png",
    },
    {
      id: 8,
      title: "RPJ Hotel",
      year: "2024",
      img: "/assets/card2.png", 
    },
    {
      id: 9,
      title: "Soham Villas",
      year: "2025",
      img: "/assets/card3.png",
    },
  ];

  const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};


const fadeLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.9, ease: "easeOut" },
  },
};

const fadeRight = {
  hidden: { opacity: 0, x: 80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.9, ease: "easeOut" },
  },
};

  return (
    <div className="overflow-x-hidden">
      <Header />

      <div className="w-full min-h-screen bg-white flex items-center px-4 sm:px-6 lg:px-12 2xl:px-24 pt-6">
      <div className="grid grid-cols-1 lg:grid-cols-[30%_10%_60%] w-full items-center">

        <div className="relative hidden lg:flex items-center justify-center w-full">
          <svg
            viewBox="0 0 120 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className=" absolute left-1/2 -translate-x-1/2 scale-x-[-1] h-[420px] xl:h-[500px] 2xl:h-[620px]"
          >
            <path
              d="M120 0C20 200 20 600 120 800"
              stroke="#F97316"
              strokeWidth="3"
            />
          </svg>

          <div className="relative z-10 w-24 xl:w-28 2xl:w-36 ">
            <img
              src="./assets/brochur.png"
              alt="Brochure Preview"
              className="w-full h-auto rounded-xl"
            />
          </div>
        </div>

        <div className="hidden lg:block" />
        <div className="max-w-full lg:max-w-3xl 2xl:max-w-4xl mx-auto lg:ml-5"> 

          <div className="flex justify-center lg:justify-center w-full xl:-ml-8 lg:-ml-12">
            <p className="bodyFont font-extrabold text-sm xl:text-lg 2xl:text-xl text-[#383838] text-center lg:text-right animate-zoom-in">
              Brochure&nbsp;Creation
            </p>
          </div>


          <h1 className="heading text-center lg:text-left animate-zoom-in
            text-[2.7rem] lg:text-[6rem] md:text-[5rem]
            leading-tight tracking-[0.08em] text-black">

            INNOVATION <br />
            STARTS{" "}
            <span className="relative inline-block text-[#F56E0F] bg-orange-100 px-2 border-2 border-[#F56E0F]">
              HERE.
              <span className="absolute -top-1 -left-1 w-2 h-2 bg-[#F56E0F]" />
              <span className="absolute -top-1 -right-1 w-2 h-2 bg-[#F56E0F]" />
              <span className="absolute -bottom-1 -left-1 w-2 h-2 bg-[#F56E0F]" />
              <span className="absolute -bottom-1 -right-1 w-2 h-2 bg-[#F56E0F]" />
            </span>

          </h1>
          <style jsx global>{`
              @keyframes zoomInGrow {
                0% {
                  opacity: 0;
                  transform: scale(0.9);
                }
                100% {
                  opacity: 1;
                  transform: scale(1);
                }
              }

              .animate-zoom-in {
                animation: zoomInGrow 1.2s ease-out forwards;
              }
            `}</style>

          
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-32 mt-8 lg:mt-12">

            <div className="flex items-center group">
              {/* <button className="bodyFont bg-orange-500 text-white px-6 py-3 text-sm xl:text-base rounded-full hover:bg-orange-600 transition">
                Connect
              </button>

              <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#ED772F] bg-white transition-all duration-300">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#ED772F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
                >
                  <line x1="7" y1="17" x2="17" y2="7" />
                  <polyline points="7 7 17 7 17 17" />
                </svg>
              </div> */}
              
              <div className="joint_btn arrow_btn-wrapper bg-[#F56E0F] w-24 h-10 rounded-full cursor-pointer flex items-center justify-center text-white">Connect</div>
                  <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                    <span className="arrow_btn__icon-wrapper_white">
                      <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                        <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                      </svg>
                      <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                        <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                      </svg>
                    </span>
                  </div>
                </div>
      
            <p className="montserrat text-center lg:text-left text-sm sm:text-base xl:text-lg 2xl:text-xl text-[#383838] max-w-sm">
              Your brand’s journey to creativity begins with us, where ideas become masterpieces.
            </p>
          </div>
        </div>
      </div>
    </div>

     <div className="w-full bg-[#E3E3D2] overflow-hidden">
  <div className="slide-track flex animate-scroll">
    {[..."CORPORATE PRODUCT SERVICE REAL ESTATE EVENT DIGITAL INFORMATIONAL".split(" "), 
      ..."CORPORATE PRODUCT SERVICE REAL ESTATE EVENT DIGITAL INFORMATIONAL".split(" ")].map((item, index) => (
      <h1
        key={index}
        className="heading px-16 py-4 text-[#595757] uppercase text-6xl tracking-widest whitespace-nowrap"
      >
        {item}
      </h1>
    ))}
  </div>

  <style>
    {`
      /* Smooth infinite scroll */
      @keyframes scroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }

      .animate-scroll {
        display: flex;
        width: max-content;
        animation: scroll 25s linear infinite;
      }

      /* Optional: Remove selection highlight while scrolling */
      .heading {
        user-select: none;
      }
    `}
  </style>
</div>


      <div className="w-full bg-white py-10 px-4 md:px-8 lg:px-20 ">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[30%_60%_10%] items-center gap-10">

          {/* <p className="montserrat text-base md:text-lg text-[#383838] max-w-xs">
            Every brochure is designed <br />
            to engage, inform, and <br />
            inspire your audience.
          </p>

          <h2 className="bodyFont text-left lg:text-left text-3xl md:text-5xl xl:text-6xl lg:text-5xl text-[#212121] leading-tight">
            Crafting&nbsp;Visual&nbsp;<br className="md:hidden block"/>Stories<br className="hidden md:block"/> That Speak
          </h2>

          <div className="flex justify-start lg:justify-end">
            <div className="mr-5 lg:mt-20 w-12 h-12 rounded-full border border-[#ED772F] flex items-center justify-center cursor-pointer hover:bg-[#ED772F] group transition">
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ED772F"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="group-hover:stroke-white transition"
              >
                <line x1="7" y1="17" x2="17" y2="7" />
                <polyline points="7 7 17 7 17 17" />
              </svg>
            </div>
          </div> */}
           <motion.p
                       variants={fadeLeft}
                       initial="hidden"
                       whileInView="visible"
                       viewport={{ once: true }}
                       className="montserrat text-base md:text-lg text-[#383838] max-w-xs"
                     >
           {/* <p className="montserrat text-base md:text-lg text-[#383838] max-w-xs"> */}
            Every brochure is designed <br />
            to engage, inform, and <br />
            inspire your audience.
          {/* </p> */}
          </motion.p>

          <div className="flex items-start justify-between gap-6">
            <motion.h2
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        className="bodyFont text-left text-3xl md:text-5xl xl:text-6xl text-[#212121] leading-tight"
                      >
            {/* <h2 className="bodyFont text-left text-3xl md:text-5xl xl:text-6xl text-[#212121] leading-tight"> */}
              Crafting&nbsp;Visual&nbsp;
              <br className="md:hidden block" />
              Stories
              <br className="hidden md:block" />
              That Speak
            {/* </h2> */}
            </motion.h2>

            <div className="w-12 h-12 rounded-full border border-[#ED772F] flex items-center justify-center cursor-pointer hover:bg-[#ED772F] group transition shrink-0">
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ED772F"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="group-hover:stroke-white transition"
              >
                <line x1="7" y1="17" x2="17" y2="7" />
                <polyline points="7 7 17 7 17 17" />
              </svg>
            </div>
          </div>

        </div>
      </div>
    
      <div className="w-full py-16 px-4 sm:px-8 lg:px-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-8">
          
          <motion.div
                      variants={fadeLeft}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      className="flex-shrink-0"
                    >
          {/* <div className="flex-shrink-0"> */}
            <img
              src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/535010083.jpg?k=d5d0dc5d6595b191555ad8be3b9d64c5e71eb66604fbe95bb43c4db8da4a61d2&o=" 
              alt="img"
              className="w-[500px] h-[400px] lg:w-[300px] xl:w-[500px] rounded-xl object-cover"
            />
          {/* </div> */}
          </motion.div>

          <div className="flex-1 text-left px-4 lg:ml-10 md:mr-40 xl:mr-0 relative">
          {/* <motion.div
                      variants={fadeRight}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      className="flex-1 text-left px-4 lg:ml-10 md:mr-40 xl:mr-0 relative"
                    > */}
          <h3 className="text-2xl md:text-xl montserrat font-semibold text-black">
            Redefining the Ordinary
          </h3>

          <p className="mt-2 text-black text-base md:text-xl xl:w-[500px] md:w-[300px]">
            Open Studios brings creativity, craft, <br className="hidden xl:block" />
            and strategy together, designing <br className="hidden xl:block" />
            brochures that are not just seen but <br className="hidden xl:block" />
            remembered.
          </p>

          <div className="mt-4 lg:mt-0 lg:absolute xl:right-0 2xl:left-[20vw] lg:left-[30vw] lg:top-52 lg:-translate-y-1/2">
            <button className="bg-orange-500 text-white px-6 py-3 rounded-full hover:bg-orange-600 transition">
              Connect&nbsp;With&nbsp;Us
            </button>
          </div>
          {/* </motion.div> */}
        </div>
        </div>
      </div>

      {/* div */}
      <div className="w-full bg-white py-20 px-4 hidden lg:block">

      <motion.h2
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  className="text-center text-3xl sm:text-4xl font-medium text-[#1c1c1c] mb-16"
                >
      {/* <h2 className="text-center text-3xl sm:text-4xl font-medium text-[#1c1c1c] mb-16"> */}
        What We Make <br className="sm:hidden md:block" /> Possible
      {/* </h2> */}
      </motion.h2>

      <div className="relative max-w-6xl mx-auto px-6 sm:px-14 py-20">
        
        <div className="grid grid-cols-1 sm:grid-cols-3 items-center gap-14">
          
          <div className="flex justify-center sm:justify-start">
            <div className="w-[330px] h-[300px] border border-dashed border-[#FF5900] rounded-xl p-5 flex flex-col justify-between
                transition-shadow duration-300 hover:shadow-xl">
              <div className="flex items-start gap-3">
                <span className="inline-block w-6 h-6 bg-gray-500 rounded"></span>
                <h4 className="bodyFont text-lg font-medium gap-2 ">
                  Story-First <br />Designs
                </h4>
              </div>
              <p className="montserrat text-md text-gray-500 leading-relaxed">
                Because your brand deserves to be remembered.
              </p>
            </div>
          </div>

          <div className="relative flex justify-center group">
          <div className="absolute -left-20 -top-10 w-64 h-80 rounded-xl rotate-[-15deg] hidden sm:block overflow-hidden
            transition-transform duration-300 group-hover:scale-105">
            <img
              src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/535010083.jpg?k=d5d0dc5d6595b191555ad8be3b9d64c5e71eb66604fbe95bb43c4db8da4a61d2&o="
              alt="design"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="relative z-10 w-64 h-80 bg-[#1c1c1c] rounded-xl rotate-12 p-10 text-white shadow-xl
            -right-16 -top-9 flex flex-col justify-between
            transition-all duration-300 group-hover:rotate-6 group-hover:scale-105">
            
            <div className="flex items-start gap-3">
              <span className="inline-block w-6 h-6 bg-orange-500 rounded"></span>
              <h4 className="bodyFont text-lg font-medium">
                Layouts <br /> That Pop
              </h4>
            </div>

            <p className="montserrat text-md text-white leading-relaxed">
              Typography, colours, images, yes, we obsess over every pixel.
            </p>
          </div>
        </div>
          <div className="flex justify-center sm:justify-end">
           <div className="w-[330px] h-[300px] border border-dashed border-[#FF5900] rounded-xl p-5 flex flex-col justify-between
              transition-shadow duration-300 hover:shadow-xl">
              <div className="flex items-start gap-3 ml-3">
                <span className="inline-block w-6 h-6 bg-black rounded"></span>
                <h4 className="bodyFont text-lg font-medium gap-2 ">
                  Custom for <br />You
                </h4>
              </div>
              <p className="montserrat text-md text-gray-500 leading-relaxed">
                Corporate, product, event, or promotional, your goals, our blueprint.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-16 flex justify-center">
          <div className="flex items-center group">
              {/* <button className="bodyFont bg-orange-500 text-white px-6 py-3 text-sm xl:text-base rounded-full hover:bg-orange-600 transition">
                Let’s Connect
              </button>
              <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#ED772F] bg-white transition-all duration-300">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#ED772F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1">
                  <line x1="7" y1="17" x2="17" y2="7" />
                  <polyline points="7 7 17 7 17 17" />
                </svg>
              </div> */}
              <div className="joint_btn arrow_btn-wrapper bg-[#F56E0F] w-32 h-10 rounded-full cursor-pointer flex items-center justify-center text-white">Let’s Connect</div>
                  <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                    <span className="arrow_btn__icon-wrapper_white">
                      <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                        <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                      </svg>
                      <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
                        <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                      </svg>
                    </span>
                  </div>
                </div>
            </div>
        </div>
      </div>

    {/* mobile */}
   <div className="w-full bg-white py-12 px-6 block lg:hidden overflow-hidden">

      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center text-3xl font-medium text-[#1c1c1c] mb-10"
      >
        What We Make <br /> Possible
      </motion.h2>

      <div className="relative h-[460px] flex justify-center items-center">

        <AnimatePresence mode="wait">
          {active === 0 && (
            <motion.div
              key="slide-1"
              initial={{ opacity: 0, x: -80 }}   
              animate={{ opacity: 1, x: 0 }}   
              exit={{ opacity: 0, x: -80 }} 
              transition={{ duration: 0.4 }}
              className="flex justify-center w-full"
            >
              <div className="w-[330px] h-[300px] border border-dashed border-[#FF5900] rounded-xl p-5 flex flex-col justify-between hover:shadow-xl">
                <div className="flex items-start gap-3">
                  <span className="w-6 h-6 bg-gray-500 rounded" />
                  <h4 className="text-lg font-medium">
                    Story-First <br /> Designs
                  </h4>
                </div>
                <p className="text-gray-500">
                  Because your brand deserves to be remembered.
                </p>
              </div>
            </motion.div>
          )}

          {active === 1 && (
            <motion.div
              key="slide-2"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.4 }}
              className="relative flex justify-center items-center w-full h-[450px]"
            >
              <div className="absolute w-64 h-80 rounded-2xl rotate-[-9deg] overflow-hidden shadow-lg -translate-x-4">
                <img
                  src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/535010083.jpg?k=d5d0dc5d6595b191555ad8be3b9d64c5e71eb66604fbe95bb43c4db8da4a61d2&o="
                  alt="img"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="relative z-10 w-64 h-80 bg-[#1c1c1c] rounded-2xl rotate-[8deg] p-8 text-white shadow-2xl translate-x-4">
                <div className="flex flex-col h-full justify-between">
                  <div>
                    <div className="w-8 h-8 bg-orange-500 rounded-lg mb-4" />
                    <h4 className="text-2xl font-semibold mb-2">
                      Layouts <br /> That Pop
                    </h4>
                  </div>
                  <p className="text-gray-300 text-sm">
                    Typography, colours, images, yes, we obsess over every pixel.
                  </p>
                </div>
              </div>
            </motion.div>
          )}

          {active === 2 && (
            <motion.div
              key="slide-3"
              initial={{ opacity: 0, x: 80 }} 
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -80 }}  
              transition={{ duration: 0.4 }}
              className="flex justify-center w-full"
            >
              <div className="w-[330px] h-[300px] border border-dashed border-[#FF5900] rounded-xl p-5 flex flex-col justify-between hover:shadow-xl">
                <div className="flex items-start gap-3 ml-3">
                  <span className="w-6 h-6 bg-black rounded" />
                  <h4 className="text-lg font-medium">
                    Custom for <br /> You
                  </h4>
                </div>
                <p className="text-gray-500">
                  Corporate, product, event, or promotional — your goals, our blueprint.
                </p>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <div className="flex justify-center gap-3 mt-6">
        {slides.map((i) => (
          <button
            key={i}
            onClick={() => handleDotClick(i)}
            className={`w-2.5 h-2.5 rounded-full transition-all ${
              active === i
                ? "bg-orange-500 scale-125"
                : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </div>

    <div className="bg-[#E3E3D2] py-20 px-6 sm:px-10 lg:px-20 mb-0">

        <div className="max-w-7xl mx-auto space-y-10">

          {/* ===== 1 ===== */}
          <div>
            {/* <div
              onClick={() => toggleAccordion(0)}
              className="flex items-center justify-between cursor-pointer"
            >
              <h2 className="heading text-2xl sm:text-5xl lg:text-7xl uppercase text-[#593013]">
                Corporate & Branding Brochures
              </h2>

              <span
                className={`w-12 h-12 rounded-full border flex items-center justify-center text-5xl
                  ${openIndex === 0
                    ? "bg-white border-[#593013] text-[#593013]"  
                    : "bg-white border-white text-[#593013]"              
                  }`}
              >
                {openIndex === 0 ? "−" : "+"}
              </span>

            </div> */}
            <div
              onClick={() => toggleAccordion(0)}
              className="group flex items-center justify-between cursor-pointer"
            >
              <h2
                className={`heading text-3xl sm:text-5xl lg:text-7xl uppercase 
                  transition-colors duration-300
                  ${
                    openIndex === 0
                      ? "text-orange-500"
                      : "text-[#593013] group-hover:text-orange-500"
                  }`}
              >
                Corporate & Branding Brochures
              </h2>

              <span
                className={`w-12 h-12 rounded-full border flex items-center justify-center text-5xl
                  transition-colors duration-300
                  ${
                    openIndex === 0
                      ? "bg-white border-[#593013] text-[#593013]"
                      : "bg-white border-white text-[#593013]"
                  }`}
              >
                {openIndex === 0 ? "−" : "+"}
              </span>
            </div>

            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === 0 ? "max-h-40 opacity-100 mt-6" : "max-h-0 opacity-0"
                }`}
            >
              <p className="max-w-3xl text-[#593013] text-base sm:text-lg">
                We define your brand’s direction, positioning, voice, and long-term
                vision so it connects emotionally and performs commercially.
              </p>
            </div>
          </div>

          {/* ===== 2 ===== */}
          <div>
            <div
              onClick={() => toggleAccordion(1)}
              className="group flex items-center justify-between cursor-pointer"
            >
              <h2
                className={`heading text-3xl sm:text-5xl lg:text-7xl uppercase 
                  transition-colors duration-300
                  ${
                    openIndex === 1
                      ? "text-orange-500"
                      : "text-[#593013] group-hover:text-orange-500"
                  }`}
              >
                Product & Service Showcases
              </h2>

              <span
                className={`w-12 h-12 rounded-full border flex items-center justify-center text-5xl
                  transition-colors duration-300
                  ${
                    openIndex === 1
                      ? "bg-white border-[#593013] text-[#593013]"
                      : "bg-white border-white text-[#593013]"
                  }`}
              >
                {openIndex === 1 ? "−" : "+"}
              </span>
            </div>


            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === 1 ? "max-h-40 opacity-100 mt-6" : "max-h-0 opacity-0"
                }`}
            >
              <p className="max-w-3xl text-[#593013] text-base sm:text-lg">
                Logos, typography, color systems, and visual language that make your
                brand instantly recognizable and memorable.
              </p>
            </div>
          </div>

          {/* ===== 3 ===== */}
          <div>
            <div
              onClick={() => toggleAccordion(2)}
              className="group flex items-center justify-between cursor-pointer"
            >
              <h2
                className={`heading text-3xl sm:text-5xl lg:text-7xl uppercase
                  transition-colors duration-300
                  ${
                    openIndex === 2
                      ? "text-orange-500"
                      : "text-[#593013] group-hover:text-orange-500"
                  }`}
              >
                Event & Promotional Brochures
              </h2>

              <span
                className={`w-12 h-12 rounded-full border flex items-center justify-center text-5xl
                  transition-colors duration-300
                  ${
                    openIndex === 2
                      ? "bg-white border-[#593013] text-[#593013]"
                      : "bg-white border-white text-[#593013]"
                  }`}
              >
                {openIndex === 2 ? "−" : "+"}
              </span>
            </div>

            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === 2 ? "max-h-40 opacity-100 mt-6" : "max-h-0 opacity-0"
                }`}
            >
              <p className="max-w-3xl text-[#593013] text-base sm:text-lg">
                We craft narratives and messaging frameworks that communicate who you
                are, why you exist, and why people should care.
              </p>
            </div>
          </div>

          {/* ===== 4 ===== */}
          <div>
            <div
              onClick={() => toggleAccordion(3)}
              className="group flex items-center justify-between cursor-pointer"
            >
              <h2
                className={`heading text-3xl sm:text-5xl lg:text-7xl uppercase
                  transition-colors duration-300
                  ${
                    openIndex === 3
                      ? "text-[#F56E0F]"
                      : "text-[#593013] group-hover:text-[#F56E0F]"
                  }`}
              >
                Digital & Interactive Brochures
              </h2>

              <span
                className={`w-12 h-12 rounded-full border flex items-center justify-center text-5xl
                  transition-colors duration-300
                  ${
                    openIndex === 3
                      ? "bg-white border-[#593013] text-[#593013]"
                      : "bg-white border-white text-[#593013]"
                  }`}
              >
                {openIndex === 3 ? "−" : "+"}
              </span>
            </div>

            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === 3 ? "max-h-40 opacity-100 mt-6" : "max-h-0 opacity-0"
                }`}
            >
              <p className="max-w-3xl text-[#593013] text-base sm:text-lg">
                From internal alignment to market launch, we ensure your brand enters
                the world with clarity, consistency, and impact.
              </p>
            </div>
          </div>

        </div>
      </div>

    <div className="w-full bg-white px-4 sm:px-8 lg:px-20 py-10 border-t border-gray-200">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        
       <motion.h2
                   variants={fadeLeft}
                   initial="hidden"
                   whileInView="visible"
                   viewport={{ once: true }}
                   className="bodyFont text-2xl sm:text-3xl lg:text-5xl font-medium text-[#212121] text-center sm:text-left"
                 >
        {/* <h2 className="bodyFont text-2xl sm:text-3xl lg:text-5xl font-medium text-[#212121] text-center sm:text-left"> */}
          The Latest Works in Our <br className="hidden sm:block" />
          Creative Journey
        {/* </h2> */}
        </motion.h2>

        {/* <div className="flex items-center group cursor-pointer"> */}
        <motion.div
                    variants={fadeRight}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    className="flex items-center group cursor-pointer"
                  >
          {/* <button className="bg-orange-500 text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-orange-600 transition">
            Contact Us
          </button>

          <div className="w-10 h-10 flex items-center justify-center rounded-full border border-orange-500 bg-white transition-all duration-300">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#F97316"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
            >
              <line x1="7" y1="17" x2="17" y2="7" />
              <polyline points="7 7 17 7 17 17" />
            </svg>
          </div> */}
          <div className="joint_btn arrow_btn-wrapper bg-[#F56E0F] w-28 h-10 rounded-full cursor-pointer flex items-center justify-center text-white">Connect Us</div>
                  <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
                    <span className="arrow_btn__icon-wrapper_white">
                      <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
                  <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
                </svg>
              <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
              <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
            </svg>
           </span>
          </div>
          </motion.div>
        {/* </div> */}

      </div>
    </div>

    {/*card  */}
    <div className="hidden md:block">
    <div className="w-full bg-white py-16 overflow-hidden">
      <div
        className="
          flex gap-6 sm:gap-10 px-4 sm:px-10
          animate-infinite-marquee
          touch-pan-x
        "
      >
        {[...brochures, ...brochures].map((item, index) => (
          <div
            key={index}
            onClick={() => setActiveBrochure(item)}
            className="flex-shrink-0 cursor-pointer"
          >
            <div
              className="
                w-[220px] h-[300px]
                sm:w-[260px] sm:h-[360px]
                rounded-2xl border border-orange-400
                overflow-hidden bg-[#f5f5f0]
                transition-transform duration-300 hover:scale-105
              "
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover"
                draggable={false}
              />
            </div>

            <div className="mt-3 text-sm">
              <div className="flex justify-between">
                <span className="font-medium">{item.title}</span>
                <span className="underline">Check it out</span>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Year, {item.year}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
       
  {activeBrochure && (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center px-4">
      <button
        onClick={() => setActiveBrochure(null)}
        className="absolute top-4 right-4 sm:top-6 sm:right-6 text-white text-3xl z-50"
      >
        ✕
      </button>

      <div className="w-full max-w-[340px] h-[85vh] sm:h-[640px] bg-black rounded-[36px] p-3 shadow-2xl">
        <div className="w-full h-full bg-white rounded-[28px] overflow-hidden">
          <img
            src={activeBrochure.img}
            alt="Brochure Preview"
            className="w-full h-full object-contain"
            draggable={false}
          />
        </div>
      </div>
    </div>
  )}
   </div>
   <style>
  {`
  @keyframes infinite-marquee {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  .animate-infinite-marquee {
    display: flex;
    width: max-content;
    animation: infinite-marquee 18s linear infinite;
  }

  @media (max-width: 768px) {
    .animate-infinite-marquee {
      animation-duration: 22s;
    }
  }

  /* Pause animation on hover (desktop) */
  .animate-infinite-marquee:hover {
    animation-play-state: paused;
  }
  `}
  </style>


   {/* mobile */}
    <div className="md:hidden hidden:block">
      <div className="relative w-full bg-white py-16 overflow-hidden">
        <button
          onClick={() => scroll("left")}
          className="absolute left-2 sm:left-6 top-1/2 -translate-y-1/2 z-10
                     w-10 h-10 rounded-full bg-white text-black
                     flex items-center justify-center">
          <MdArrowBackIos />
        </button>
        <button
          onClick={() => scroll("right")}
          className="absolute right-2 sm:right-6 top-1/2 -translate-y-1/2 z-10
                     w-10 h-10 rounded-full bg-white text-black
                     flex items-center justify-center ">
          <MdArrowForwardIos />
        </button>

          <div
            ref={scrollRef}
            onMouseEnter={stopAutoScroll}
            onMouseLeave={startAutoScroll}
            onTouchStart={stopAutoScroll}
            className="
              flex gap-6 sm:gap-10 px-4 sm:px-10
              overflow-x-auto scroll-smooth
              no-scrollbar"
          >
          {brochures.map((item, index) => (
            <div
              key={index}
              onClick={() => setActiveBrochure(item)}
              className="flex-shrink-0 cursor-pointer"
            >
              <div
                className="
                  w-[220px] h-[300px]
                  sm:w-[260px] sm:h-[360px]
                  rounded-2xl border border-orange-400
                  overflow-hidden bg-[#f5f5f0]
                  transition-transform duration-300 hover:scale-105
                "
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  draggable={false}
                />
              </div>

              <div className="mt-3 text-sm">
                <div className="flex justify-between">
                  <span className="font-medium">{item.title}</span>
                  <span className="underline">Check it out</span>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Year, {item.year}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {activeBrochure && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center px-4">
          <button
            onClick={() => setActiveBrochure(null)}
            className="absolute top-4 right-4 text-white text-3xl z-50"
          >
            ✕
          </button>

          <div className="w-full max-w-[340px] h-[85vh] sm:h-[640px] bg-black rounded-[36px] p-3 shadow-2xl">
            <div className="w-full h-full bg-white rounded-[28px] overflow-hidden">
              <img
                src={activeBrochure.img}
                alt="Brochure Preview"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      )}

      <style>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
      </div>

  

      <LetsGet />
      <FollowUs />          
      <Footer />
    </div>
  );
};

export default BrochureCreation;
